<!--
 * @Description: 发送注册链接
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-06-26 16:30:46
 * @LastEditors: cxh
-->
<template>
  <CosModal v-model:visible="visible" title="发送注册链接" width="670px" @ok="handleSubmit" :confirmLoading="loading">
    <a-alert
      message="选择发送方式（短信/邮箱），系统会自动将注册链接以短信/邮件形式发给客户"
      type="warning"
      show-icon
    />
    <a-form :model="editForm" ref="formRef" v-if="visible" style="margin-top: 10px">
      <a-form-item name="customerName" label="客户名称" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.customerName" :disabled="true" />
      </a-form-item>
      <a-form-item name="type" label="发送方式" :rules="[{ required: true, message: '请输入' }]">
        <a-radio-group v-model:value="editForm.type" :options="linkmethods" />
      </a-form-item>
      <template v-if="editForm.type === 'mobile'">
        <a-form-item
          name="mobile"
          label="手机号"
          :rules="!editForm.otherTel ? [{ required: true, message: '请选择' }] : []"
        >
          <a-select v-model:value="editForm.mobile" placeholder="请选择" :disabled="editForm.otherTel ? true : false">
            <a-select-option v-for="item in optionsMobile" :key="item.mobile" :value="item.mobile">{{
              `${item.mobile}(${item.name})`
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-checkbox v-model:checked="editForm.otherTel" @change="clearVaild('mobile')">使用其他手机号</a-checkbox>
        </a-form-item>
        <a-form-item
          name="mobile_other"
          label="手机号"
          v-if="editForm.otherTel"
          :rules="[
            { required: true, message: '请输入' },
            {
              validator: mobileValidate
            }
          ]"
        >
          <a-input v-model:value="editForm.mobile_other" placeholder="请输入" />
        </a-form-item>
      </template>
      <template v-else>
        <a-form-item
          name="email"
          label="邮箱"
          :rules="!editForm.otherEmail ? [{ required: true, message: '请选择' }] : []"
        >
          <a-select v-model:value="editForm.email" placeholder="请选择" :disabled="editForm.otherEmail ? true : false">
            <a-select-option v-for="(item, index) in optionsEmail" :key="index" :value="item.email">{{
              `${item.email}(${item.name})`
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-checkbox v-model:checked="editForm.otherEmail" @change="clearVaild('email')">使用其他邮箱</a-checkbox>
        </a-form-item>
        <a-form-item
          v-if="editForm.otherEmail"
          label="邮箱"
          name="email_other"
          :rules="[
            { required: true, message: '请输入' },
            {
              validator: emailValidate
            }
          ]"
        >
          <a-input v-model:value="editForm.email_other" placeholder="请输入" />
        </a-form-item>
      </template>
    </a-form>
  </CosModal>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { sentEmail, sentMobileMsg, customerContactSelect } from '@/api/gucangSales/customerCenter'
import { mobileValidate, emailValidate } from '@/utils/validate'
import type { PotentialItem } from '@/typings/api/customerCenter'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const optionsMobile = ref<any>([])
const optionsEmail = ref<any>([])
const editForm = ref<any>({})
const linkmethods = [
  { label: '短信', value: 'mobile' },
  { label: '邮件', value: 'email' }
]
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    try {
      const { otherTel, otherEmail } = editForm.value
      if (editForm.value.type === 'mobile') {
        await sentMobileMsg({
          cosId: editForm.value.cosId,
          mobile: otherTel ? editForm.value.mobile_other : editForm.value.mobile
        })
      } else if (editForm.value.type === 'email') {
        const email = editForm.value.email && editForm.value.email
        await sentEmail({
          cosId: editForm.value.cosId,
          email: otherEmail ? editForm.value.email_other : email
        })
      }
      loading.value = false
      message.success('发送成功')
      visible.value = false
    } catch (error) {
      loading.value = false
    }
  })
}
const toggle = (rows: PotentialItem) => {
  editForm.value = {
    type: 'mobile',
    cosId: rows.cosId,
    customerName: rows.customerName
  }
  visible.value = true
  if (rows.cosId) {
    fetch(rows.cosId)
  }
}
// 获取联系人列表
const fetch = (cosId: string) => {
  customerContactSelect({ cosId }).then((res) => {
    optionsMobile.value = res.data.filter((item: any) => item.mobile)
    if (optionsMobile.value && optionsMobile.value.length) {
      editForm.value.mobile = optionsMobile.value[0].mobile
    }
    optionsEmail.value = res.data.filter((item: any) => item.email)
    if (optionsEmail.value && optionsEmail.value.length) {
      editForm.value.email = optionsEmail.value[0].email
    }
  })
}
// 清楚校验
const clearVaild = (type: 'mobile' | 'email') => {
  if (type === 'mobile') {
    formRef.value?.clearValidate(['mobile', 'mobile_other'])
  } else if (type === 'email') {
    formRef.value?.clearValidate(['email', 'email_other'])
  }
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'sendLinkModel' }
</script>
<style lang="scss" scoped>
.clueMerge {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex1 {
  flex: 1;
}
</style>
